// action - state management
import { LOGIN, LOGOUT } from './actions';

export const initialState = {
    isLoggedIn: false,
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN: {
            return {
                ...state,
                isLoggedIn: true,
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
